module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "flexContainers",
    attrs: {
      "id": "modal"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "flexContainer abs",
    attrs: {
      "id": "spinnerLoader"
    }
  }, [_c('Spinner', {
    staticClass: "loader",
    attrs: {
      "animation-duration": 5000,
      "size": 60,
      "color": '#41b4e8'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wishlist"
  }, [(_vm.isDisplayAddList) ? _c('AddList') : _vm._e(), _vm._v(" "), _c('header', {
    staticClass: "wishlist-header"
  }, [_c('i', {
    staticClass: "icon-close",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("wishlist.title")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("wishlist.title2")))])]), _vm._v(" "), _c('main', {
    staticClass: "wishlist-main"
  }, _vm._l((_vm.getLists), function(list, i) {
    return _c('div', {
      key: i,
      staticClass: "content-list"
    }, [_c('div', {
      staticClass: "wishlist-name",
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.getMode === 'add' ? _vm.addToList(list) : _vm.displayComponents(i);
        }
      }
    }, [_vm._v("\n                    " + _vm._s(list.name) + " (" + _vm._s(_vm.getCountComponent(list)) + " items)\n                ")]), _vm._v(" "), (_vm.editName && _vm.editIndex === i) ? _c('div', {
      staticClass: "wishlist-name"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editBookName.name),
        expression: "editBookName.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.editBookName.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editBookName.name = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.saveUpdate();
        }
      }
    }, [_vm._v("OK")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "content-btn-export"
    }, [(_vm.getMode !== 'add') ? _c('img', {
      attrs: {
        "src": require("../../../static/assets/mod-icon.svg"),
        "height": "20",
        "width": "20",
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.updateList(list, i);
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.getMode !== 'add') ? _c('img', {
      attrs: {
        "src": require("../../../static/assets/delete-icon.svg"),
        "height": "20",
        "width": "20",
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.deleteList(list);
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.getMode === 'export' && _vm.getCountComponent(list) > 0) ? _c('img', {
      attrs: {
        "src": require("../../../static/assets/download.svg"),
        "height": "20",
        "width": "20",
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.exportPdf(list);
        }
      }
    }) : _vm._e()]), _vm._v(" "), (_vm.getMode !== 'add' && list.data && list.data.components && list.data.components.length > 0 && _vm.canDisplayComponents === i) ? _c('div', [_c('ul', {
      staticClass: "content-components"
    }, _vm._l((list.data.components), function(component) {
      return _c('li', {
        key: component.id,
        staticClass: "content-component"
      }, [_vm._v("\n                            " + _vm._s(_vm.getComponentName(component)) + "   " + _vm._s(component.type ? "[ " + component.type + " ]" : "") + "\n                            "), _c('i', {
        staticClass: "delete-component",
        on: {
          "click": function($event) {
            _vm.deleteComponent(list, component);
          }
        }
      })])
    }))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "content-wishlist-action"
    })])
  })), _vm._v(" "), _c('footer', {
    staticClass: "wishlist-footer"
  }, [_c('button', {
    staticClass: "btnExp",
    on: {
      "click": _vm.addNewList
    }
  }, [_vm._v(_vm._s(_vm.$t("wishlist.btadd")))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56a17956","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wishlist/WishList.vue
// module id = 3194
// module chunks = 0